import { request } from './http.js'

export async function fetchLoginLogs({ username = '', page = 1, pageSize = 20 } = {}) {
  const params = new URLSearchParams()
  if (username) params.set('username', username)
  params.set('page', String(page))
  params.set('pageSize', String(pageSize))
  return request(`/api/login-logs?${params.toString()}`)
}
